/* --------------------------------------------------------
  Javascript for The Laminator Warehouse

  version: 0.2
  last modified: 19.11.2020 by Georgi Danchev
  author: Georgi Danchev
  email: george.danchev@kubixmedia.co.uk
  website: https://kubixmedia.co.uk
---------------------------------------------------------- */

// import "jquery";
import "jquery-match-height";
import "slick-carousel";

import GridItemsHeights from "./modules/grid-items-heights";
import UspsBanner from "./modules/usps-banner";
import ScrollToViewHelper from "./modules/scroll-to-view-helper";

const gridItemsHeights = new GridItemsHeights();
const uspsBanner = new UspsBanner();
const scrollToViewHelper = new ScrollToViewHelper();
